module.exports = __webpack_public_path__ + "static/media/transfer-out.7b102327.webp";